<template>
  <div class="data-table" ref="dataTable">
    <a-table
      :loading="loading"
      :columns="columns"
      :data-source="data"
      :row-key="(record, index) => index"
      :pagination="false"
      :scroll="scroll"
    >
      <div slot="syncAuthorCount" slot-scope="text, record">
        <router-link
          :to="{ name: 'authorGroupList', query: { dealerGroupName: record.groupName } }"
          target="_blank"
        >
          {{ record.syncAuthorCount | humanReadable }}
        </router-link>
      </div>
      <div class="operate" slot="operate" slot-scope="text, record">
        <router-link
          :to="{ name: 'dealerGroupDetail', params: { groupId: record.groupId } }"
          target="_blank"
        >
          {{ record.isCreator === 1 ? '查看编辑' : '查看详情' }}
        </router-link>

        <template v-if="record.isCreator !== 1">
          <a-divider type="vertical" />
          <a v-if="record.isFollowed === 1" @click="handleOperate('unfollow', record)">取消关注</a>
          <a v-else @click="handleOperate('follow', record)">关注</a>
        </template>
        
        <a-divider type="vertical" />
        <a @click="handleOperate('copy', record)">复制</a>

        <template v-if="record.isCreator === 1">
          <a-divider type="vertical" />
          <a @click="handleOperate('delete', record)">删除</a>
        </template>
        
      </div>
    </a-table>

    <BasePagination
      ref="basePagination"
      :currentPage="pagination.page"
      :pageSize="pagination.size"
      :total="pagination.total"
      @onChange="handlePaginationChange"
      @onShowSizeChange="handlePaginationChange"
    />
  </div>
</template>

<script>
import resizeMixin from '@/mixins/dataTableMixin'
import formatUtil from '@/utils/FormatUtil'

const columns = [
  {
    title: '经销商分组',
    key: 'groupName',
    width: 250,
    customRender: (text, record, index) => {
      return record.groupName || '-'
    }
  },
  {
    title: '分组编号',
    key: 'groupCode',
    width: 150,
    customRender: (text, record, index) => {
      return record.groupCode || '-'
    }
  },
  {
    title: '包含经销商',
    key: 'dealerTotal',
    width: 150,
    customRender: (text, record, index) => {
      return formatUtil.humanReadable(record.dealerTotal)
    }
  },
  {
    title: '同步播主分组',
    key: 'syncAuthorCount',
    width: 150,
    scopedSlots: { customRender: 'syncAuthorCount' }
  },
  {
    title: '负责人',
    key: 'leaderName',
    width: 150,
    customRender: (text, record, index) => {
      return record.leaderName || '-'
    }
  },
  {
    title: '创建人',
    key: 'creatorName',
    width: 150,
    customRender: (text, record, index) => {
      return record.creatorName || '-'
    }
  },
  {
    title: '更新时间',
    key: 'mtime',
    width: 180,
    customRender: (text, record, index) => {
      return record.mtime || '-'
    }
  },
  {
    title: '创建时间',
    key: 'ctime',
    width: 180,
    customRender: (text, record, index) => {
      return record.ctime || '-'
    }
  },
  {
    title: '操作',
    key: 'operate',
    width: 212,
    fixed: 'right',
    scopedSlots: { customRender: 'operate' }
  }
]

export default {
  name: 'DataTable',
  mixins: [resizeMixin],
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    pagination: {
      type: Object,
      default() {
        return {
          page: 1,
          size: 10,
          total: 0
        }
      }
    }
  },
  data() {
    return {
      columns,
      scroll: {}
    }
  },
  watch: {
    data() {
      this.$nextTick(() => {
        this.setTableScroll()
      })
    }
  },
  methods: {
    handlePaginationChange(page, size) {
      this.$emit('pagination-change', page, size)
    },
    handleOperate(type, record) {
      this.$emit('operate', type, record)
    },
    setTableScroll() {
      const winHeight = document.documentElement.offsetHeight || document.body.offsetHeight
      const width = this.$refs.dataTable.offsetWidth
      const height = this.$refs.dataTable.offsetHeight
      const columnsWidth = this.columns.reduce((total, currVal) => {
        return total + currVal.width;
      }, 0)
      const scroll = {}

      if (width - 48 < columnsWidth) {
        scroll.x = columnsWidth
      }

      if (height + 142 > winHeight) {
        const actionBarHeight = this.$refs.actionBar ? this.$refs.actionBar.$el.offsetHeight : 0
        const tableHeadHeight = document.querySelector('.ant-table-thead').offsetHeight
        const otherHeight  = actionBarHeight + tableHeadHeight + 190
        
        scroll.y = `calc(100vh - ${otherHeight}px)`
      }

      this.scroll = scroll
    }
  },
  mounted() {
    this.setTableScroll()
    this.$_resizeHandler = () => {
      this.setTableScroll()
    }
  }
}
</script>

<style lang="scss" scoped>
.data-table {
  padding: 24px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 2px;
}
</style>
